import "./PersonMissionBalancesheetHeader.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useGeneralContext } from "api/directory/general/GeneralProvider";
import { getEntityIsAllowedBySlug } from "utils/helper";

const PersonMissionBalancesheetHeader = ({
  missionName,
  clientName,
  clientSlug,
  workerName,
  workerSlug,
  userScope,
  onClickExport,
}) => {
  const { namesByFilters } = useGeneralContext() || {};
  const isClientAllowed = getEntityIsAllowedBySlug(clientSlug, namesByFilters);
  const isWorkerAllowed = getEntityIsAllowedBySlug(workerSlug, namesByFilters);

  return (
    <div className="evaluation-header">
      <div className="section-info">
        <h1 className="header-title">
          Évaluation de la mission Davidson - “{missionName}”
        </h1>
        {isClientAllowed === false ? (
          <span className="client-title">{clientName}</span>
        ) : (
          <Link
            className="client-title"
            to={`/${userScope}/client/${clientSlug}`}
          >
            {clientName}
          </Link>
        )}
        <h6 className="worker-title">
          {isWorkerAllowed === false ? (
            <span>Profile {workerName}</span>
          ) : (
            <Link to={`/${userScope}/consultant/${workerSlug}`}>
              Profile {workerName}
            </Link>
          )}{" "}
          {`>`} Mission Évaluation
        </h6>
      </div>

      <div>
        <Button
          className="btn-outlined"
          size="medium"
          color="white"
          onClick={onClickExport}
        >
          <Icon icon="pdf-icon" color="light-slate-gray" />
          <FormattedMessage
            id={"export_pdf"}
            defaultMessage={"Exporter en PDF"}
          />
        </Button>{" "}
      </div>
    </div>
  );
};

export default PersonMissionBalancesheetHeader;

PersonMissionBalancesheetHeader.propTypes = {
  missionName: PropTypes.string,
  clientName: PropTypes.string,
  clientSlug: PropTypes.string,
  workerName: PropTypes.string,
  workerSlug: PropTypes.string,
  userScope: PropTypes.string,
  onClickExport: PropTypes.func,
};
